__turbopack_context__.v({
  "arrow": "style-module-scss-module__x9oRxq__arrow",
  "column": "style-module-scss-module__x9oRxq__column",
  "columnsContainer": "style-module-scss-module__x9oRxq__columnsContainer",
  "component": "style-module-scss-module__x9oRxq__component",
  "description": "style-module-scss-module__x9oRxq__description",
  "heading": "style-module-scss-module__x9oRxq__heading",
  "infoLink": "style-module-scss-module__x9oRxq__infoLink",
  "itemContent": "style-module-scss-module__x9oRxq__itemContent",
  "linksContainer": "style-module-scss-module__x9oRxq__linksContainer",
  "list": "style-module-scss-module__x9oRxq__list",
  "listingCount": "style-module-scss-module__x9oRxq__listingCount",
  "neighbourhoodItem": "style-module-scss-module__x9oRxq__neighbourhoodItem",
  "neighbourhoodLink": "style-module-scss-module__x9oRxq__neighbourhoodLink",
  "neighbourhoodName": "style-module-scss-module__x9oRxq__neighbourhoodName",
  "rank": "style-module-scss-module__x9oRxq__rank",
  "realEstateLink": "style-module-scss-module__x9oRxq__realEstateLink",
});
